import { IStatusPanelAngularComp } from 'ag-grid-angular';
import { IStatusPanelParams } from 'ag-grid-community';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  inject,
} from '@angular/core';

@Component({
  selector: 'app-pagination-status-bars',
  templateUrl: './pagination-status-bars.component.html',
  styleUrls: ['./pagination-status-bars.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaginationStatusBarsComponent
  implements IStatusPanelAngularComp, OnDestroy
{
  private changeDetectorRef = inject(ChangeDetectorRef);

  private params!: IStatusPanelParams;
  private paginationListener = this.onPaginationChanged.bind(this);
  currentPage = 1;
  private totalPageSize = 1;
  private rowsToShow = false;
  totalNumberOfRows = 0;
  pageRowStartIndex = 1;
  pageRowEndIndex = 50;

  agInit(params: IStatusPanelParams): void {
    this.params = params;
    this.params.api.addEventListener(
      'paginationChanged',
      this.paginationListener,
    );
  }

  onPaginationChanged(): void {
    this.totalNumberOfRows = this.params.api.getDisplayedRowCount();
    this.rowsToShow = this.totalNumberOfRows > 0;
    this.totalPageSize =
      this.params.api.paginationGetTotalPages() === 0
        ? 1
        : this.params.api.paginationGetTotalPages();
    this.getCurrentPage();
    this.changeDetectorRef.markForCheck();
  }

  getCurrentPage(): void {
    this.currentPage = this.params.api.paginationGetCurrentPage() + 1;

    const rowCount = this.params.api.getDisplayedRowCount();
    const lastGridIndex = rowCount - 1;
    const currentPage = this.params.api.paginationGetCurrentPage();
    const pageSize = this.params.api.paginationGetPageSize();
    const startPageIndex = currentPage * pageSize;
    let endPageIndex = (currentPage + 1) * pageSize - 1;

    if (endPageIndex > lastGridIndex) {
      endPageIndex = lastGridIndex;
    }
    this.pageRowStartIndex = startPageIndex + 1;
    this.pageRowEndIndex = endPageIndex + 1;
  }
  onButtonClickFirst(): void {
    this.params.api.paginationGoToFirstPage();
    this.getCurrentPage();
  }

  onButtonClickLast(): void {
    this.params.api.paginationGoToLastPage();
    this.getCurrentPage();
  }

  onButtonClickNext(): void {
    this.params.api.paginationGoToNextPage();
    this.getCurrentPage();
  }

  onButtonClickPrevious(): void {
    this.params.api.paginationGoToPreviousPage();
    this.getCurrentPage();
  }

  changePageSize($event: any): void {
    this.params.api.setGridOption('paginationPageSize', $event.value);
    this.getCurrentPage();
  }

  getTotalPageSize(): number {
    return this.totalPageSize;
  }

  hasRowsToShow(): boolean {
    return this.rowsToShow;
  }

  ngOnDestroy(): void {
    this.params?.api.removeEventListener(
      'paginationChanged',
      this.paginationListener,
    );
  }
}
